export default __webpack_public_path__ + "static/media/long_active.73ec1dfa.svg";